import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon"]

  toggle() {
    const isHidden = this.menuTarget.classList.contains("hidden")

    this.menuTarget.classList.toggle("hidden")

    if (this.hasOpenIconTarget && this.hasCloseIconTarget) {
      this.openIconTarget.classList.toggle("hidden", !isHidden)
      this.closeIconTarget.classList.toggle("hidden", isHidden)
    }

    const button = this.element.querySelector("[aria-expanded]")
    if (button) {
      button.setAttribute("aria-expanded", isHidden ? "true" : "false")
    }
  }
}
